import m from "../../node_modules/classnames/index.js";
import { jsx as s } from "../../_virtual/jsx-runtime.js";
function t({
  className: o,
  children: r
}) {
  return /* @__PURE__ */ s("div", {
    className: m("form-grid__bloc", o),
    children: r
  });
}
export {
  t as FormBloc
};
//# sourceMappingURL=FormBloc.js.map
